import React from 'react';
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CarleadTopBlueCar = () => {
  const {
    i18n
  } = useLingui();
  const listItems = ['carlead.topBlueBanner.listItem1', 'carlead.topBlueBanner.listItem2', 'carlead.topBlueBanner.listItem3'];
  return /*#__PURE__*/_jsxs("div", {
    className: "top-blue-car",
    children: [/*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12",
        children: /*#__PURE__*/_jsx("h4", {
          className: "top-blue-car__headline",
          children: i18n._('carlead.topBlueBanner.title')
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-7 col-sm-6",
        children: /*#__PURE__*/_jsx("div", {
          className: "top-blue-car__content",
          children: /*#__PURE__*/_jsx("ul", {
            className: "top-blue-car__content-list list-unstyled",
            children: listItems.map((key, index) => /*#__PURE__*/_jsx("li", {
              children: i18n._(key)
            }, index))
          })
        })
      })
    })]
  });
};
export default CarleadTopBlueCar;